import { ButtonProps } from '@chakra-ui/react';
import { Button } from '@tapresearch/ui/components';
import React, { useContext, useMemo } from 'react';
import { filterContext } from '../FilterProvider';

export interface OpenFilterButtonProps extends ButtonProps {
  omitFilters?: string[];
}

export function OpenFilterButton({
  omitFilters,
  children,
  ...rest
}: OpenFilterButtonProps) {
  const { filterValues } = useContext(filterContext);

  const hasFilters = useMemo(() => {
    const omitFiltersSet = new Set(omitFilters);
    const filterKeys = Object.keys(filterValues).filter(
      (k) => !omitFiltersSet.has(k)
    );
    return filterKeys.length > 0;
  }, [filterValues, omitFilters]);
  return (
    <Button
      {...(rest as Record<string, unknown>)}
      variant={hasFilters ? 'subtle' : 'outline'}
      isActive={hasFilters}
      fontWeight="bold"
      colorScheme={hasFilters ? 'blue' : 'gray'}
      {...(!hasFilters && {
        color: 'gray.600',
        borderColor: 'gray.400',
      })}
      _active={{
        bgColor: hasFilters ? 'blue.100' : undefined,
        _hover: {
          bgColor: hasFilters ? 'blue.300' : 'gray.200',
        },
      }}
      _hover={{
        bgColor: 'gray.100',
      }}
    >
      {children}
    </Button>
  );
}
